export default __webpack_public_path__ + "static/media/fixingBugs.01170f13.svg";